<template>
    <div v-if="params.value">{{ params.value.toLowerCase() }}</div>
</template>

<script>
	export default {
		name: 'CellRendererLowerCase',
	}
</script>
